const peru = {
  slug:"peru-discovery",
  title: 'Peru Discovery',
  duration: '9 days',
  location: 'Lima → Cusco → Sacred Valley → Machu Picchu',
  difficulty: 'Challenging',
  priceRange: '$$ (Mid-range)',
  bestTime: 'May to September (dry season)',
  description:
    "Journey through ancient Inca civilization, from Lima's culinary scene to the breathtaking wonder of Machu Picchu.",
  highlights: [
    'Machu Picchu sunrise experience',
    'Sacred Valley ruins and markets',
    "Cusco's colonial and Inca architecture",
    "Lima's world-class cuisine",
    'Andean culture and textiles'
  ],
  highlight360Views: [
  { label: "Machu Picchu", place: "Machu Picchu, Peru" },
  { label: "Cusco", place: "Cusco, Peru" },
  { label: "Sacred Valley", place: "Sacred Valley, Peru" },
  { label: "Rainbow Mountain", place: "Vinicunca Rainbow Mountain, Peru" },
  { label: "Lake Titicaca", place: "Lake Titicaca, Peru" }
],

  image:
    'https://images.unsplash.com/photo-1532996152552-eaffc4edfc1a?w=1000&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8cGVydXxlbnwwfHwwfHx8MA%3D%3D',

  days: [
    {
      day: 1,
      title: 'Arrival in Lima',
      places: [
        'Jorge Chávez International Airport',
        'Miraflores, Lima',
        'Malecón de Miraflores',
        'Parque del Amor'
      ],
      activities: [
        'Arrive at Jorge Chávez International Airport (LIM)',
        'Transfer to Miraflores district hotel',
        'Afternoon walk along Malecón cliffs',
        'Visit Parque del Amor',
        'Welcome dinner with pisco sour tasting'
      ],
      accommodation: 'Lima hotel (3-star)',
      meals: 'Dinner included'
    },
    {
      day: 2,
      title: 'Lima Exploration',
      places: [
        'Larco Museum',
        'Plaza Mayor de Lima',
        'Lima Cathedral',
        'Barranco District',
        'Puente de los Suspiros'
      ],
      activities: [
        'Morning at Larco Museum (pre-Columbian art)',
        'Historic center: Plaza de Armas, Cathedral',
        'Lunch at traditional cevichería',
        'Barranco district: Bridge of Sighs',
        'Evening food tour in Miraflores'
      ],
      accommodation: 'Lima hotel',
      meals: 'Breakfast included'
    },
    {
      day: 3,
      title: 'Lima to Cusco',
      places: [
        'Cusco International Airport',
        'Cusco City',
        'Plaza de Armas, Cusco'
      ],
      activities: [
        'Morning flight to Cusco (CUZ)',
        'Rest at hotel to acclimate to altitude',
        'Light walking: Plaza de Armas, Cathedral',
        'Coca tea to help with altitude',
        'Early dinner and rest'
      ],
      accommodation: 'Cusco hotel (3-star)',
      meals: 'Breakfast included'
    },
    {
      day: 4,
      title: 'Sacred Valley',
      places: [
        'Sacred Valley of the Incas',
        'Pisac Archaeological Park',
        'Pisac Market',
        'Ollantaytambo Fortress'
      ],
      activities: [
        'Full day Sacred Valley tour',
        'Pisac market and ruins',
        'Lunch with valley view',
        'Ollantaytambo fortress',
        'Return to Cusco or stay in Valley'
      ],
      accommodation: 'Sacred Valley hotel',
      meals: 'Breakfast and lunch included'
    },
    {
      day: 5,
      title: 'Machu Picchu Day',
      places: [
        'Ollantaytambo Train Station',
        'Aguas Calientes',
        'Machu Picchu'
      ],
      activities: [
        'Early train from Ollantaytambo to Aguas Calientes',
        'Bus up to Machu Picchu',
        'Guided tour of citadel (2-3 hours)',
        'Optional: climb Huayna Picchu or Machu Picchu Mountain',
        'Return to Aguas Calientes'
      ],
      accommodation: 'Aguas Calientes hotel',
      meals: 'Breakfast included'
    },
    {
      day: 6,
      title: 'Second Machu Picchu Visit',
      places: [
        'Machu Picchu',
        'Sun Gate (Inti Punku)',
        'Ollantaytambo',
        'Cusco City'
      ],
      activities: [
        'Optional second entry to Machu Picchu (additional fee)',
        'Morning hike to Sun Gate',
        'Explore at own pace',
        'Afternoon train back to Ollantaytambo',
        'Private transfer to Cusco'
      ],
      accommodation: 'Cusco hotel',
      meals: 'Breakfast included'
    },
    {
      day: 7,
      title: 'Cusco Ruins',
      places: [
        'Qorikancha',
        'Sacsayhuamán',
        "Q'enqo Archaeological Complex",
        'Puka Pukara',
        'San Blas, Cusco'
      ],
      activities: [
        'City tour: Qorikancha (Sun Temple)',
        "Nearby ruins: Sacsayhuamán, Q'enqo, Puka Pukara",
        'Lunch in San Blas artisan district',
        'Afternoon free for shopping',
        'Farewell dinner with traditional music'
      ],
      accommodation: 'Cusco hotel',
      meals: 'Breakfast and dinner included'
    },
    {
      day: 8,
      title: 'Rainbow Mountain (Optional)',
      places: [
        'Vinicunca Rainbow Mountain',
        'Cusco City'
      ],
      activities: [
        'OPTIONAL: Full day Vinicunca Rainbow Mountain hike',
        'Early start (4-5am)',
        'Challenging hike to 5,200m altitude',
        'Return to Cusco late afternoon',
        'OR Free day in Cusco for rest/shopping'
      ],
      accommodation: 'Cusco hotel',
      meals: 'Breakfast included'
    },
    {
      day: 9,
      title: 'Departure',
      places: [
        'San Pedro Market, Cusco',
        'Cusco International Airport',
        'Lima City'
      ],
      activities: [
        'Last minute souvenir shopping',
        'Visit local market for textiles',
        'Transfer to Cusco airport',
        'Flight to Lima for international connection',
        'Optional extension to Lake Titicaca or Amazon'
      ],
      accommodation: 'N/A',
      meals: 'Breakfast included'
    }
  ],

  inclusions: [
    '8 nights accommodation (3-star hotels)',
    'Daily breakfast, 2 lunches, 2 dinners',
    'All domestic flights (Lima-Cusco)',
    'Machu Picchu entrance fee and guided tour',
    'Sacred Valley tour',
    'Expedition train to/from Machu Picchu',
    'All transfers and transportation'
  ],
  exclusions: [
    'International flights',
    'Travel insurance',
    'Most lunches and dinners',
    'Optional activities (Rainbow Mountain, etc.)',
    'Tips and gratuities',
    'Huayna Picchu mountain permit (additional)'
  ],
  tips: [
    'Acclimatize properly to altitude',
    'Drink coca tea for altitude sickness',
    'Book Machu Picchu tickets months in advance',
    'Carry layers (temperature changes dramatically)',
    'Use sunscreen at high altitude',
    'Drink bottled water only'
  ],
  budget: {
    flights: '$600-1000',
    accommodation: '$50-100/night',
    food: '$20-40/day',
    activities: '$50-100/day',
    transport: '$20-40/day',
    total: '$1500-2500 per person'
  }
};

export default peru;
